<template>
  <!-- 推广记录 -->
  <div class="el-card  pd20">
    <!-- add---新增 -->
    <div class="box">
      <!--  -->
      <div class="search">
        <!--  -->
        <div class="search-gropu">
          推广员昵称
          <el-input class="search-child" v-model="nickname" placeholder="请输入用户昵称"></el-input>
        </div>
        <!--  -->
        <div class="search-gropu">
          购买时间
          <el-date-picker class="buy-time" v-model="buy_time" type="daterange" value-format="yyyy-MM-dd" start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
        </div>
        <el-button type="primary" @click="pullData" size="medium">搜索</el-button>
        <el-button type="primary" @click="exportExcel" size="medium">导出订单</el-button>
      </div>
    </div>
    <!--  -->
    <div class="el-card  pd20 content">
      <el-table :data="list" border style="width: 100%">
        <el-table-column type="selection" width="55"></el-table-column>
        <el-table-column type="index" width="100" label="序号"></el-table-column>
        <el-table-column prop="pay_time" label="购买时间"> </el-table-column>
        <el-table-column prop="order_no" label="订单号"> </el-table-column>
        <el-table-column label="购买人（头像昵称）">
          <template slot-scope="scope">
            <div class="userinfo">
              <img :src="scope.row.buyer_headimgurl" alt=""> {{scope.row.buyer_nickname}}
            </div>
          </template>
        </el-table-column>
        <el-table-column label="推广员（头像昵称）">
          <template slot-scope="scope">
            <div class="userinfo">
              <img :src="scope.row.headimgurl" alt=""> {{scope.row.nickname}}
            </div>
          </template>
        </el-table-column>
        <el-table-column width="90" label="订单类型">
          <template slot-scope="scope">
            {{orderType(scope.row.order_type)}}
          </template>
        </el-table-column>
        <el-table-column prop="pay_price" label="实付金额"> </el-table-column>
        <el-table-column prop="fee" label="返现金额"> </el-table-column>
      </el-table>
      <!-- 分页 -->
      <el-pagination class="pages" :page-sizes="[25, 50, 75, 100]" @size-change="handleSizeChange" @current-change="handleCurrentChange" :page-size="pages.size" :current-page="pages.page" background layout="sizes,prev, pager, next" :total="pages.count">
      </el-pagination>
    </div>
  </div>
</template>
<script>
import {
  promoterLogs,
  exportLogs
} from "@/api/operating";
import {
  exportExcel
} from "@u/tools";
export default {
  data() {
      return {
        pages: {},
        list: [],
        //
        nickname: '',
        buy_time: [],
        obj: {}
      }
    },
    methods: {
      // 导出到excel
      exportExcel() {
        let h = ['购买时间', '订单号', '购买人头像', '购买人昵称', '推广员头像', '推广员昵称', '订单类型', '实付金额', '返现金额'];
        let b = ['pay_time', 'order_no', 'buyer_headimgurl', 'buyer_nickname', 'headimgurl', 'nickname', 'order_type', 'pay_price', 'fee'];

        exportLogs(this.obj).then((res) => {

          let list = res.list; //把data里的tableData存到list
          exportExcel(h, b, list, '推广记录')

        })
      },
      // 调整每页显示条数
      handleSizeChange(val) {
        this.pages.size = val;
        this.pullData();
      },
      // 触发分页
      handleCurrentChange(val) {
        this.pages.page = val;
        this.pullData();
      },
      // 订单类型
      orderType(val) {
        if (val == 1) {
          return '普通订单'
        }
        if (val == 2) {
          return '拼团订单'
        }
        if (val == 100) {
          return '推广员订单'
        }
      },
      pullData() {
        this.$showLoading();
        this.obj = {
          page: Object.keys(this.pages).length > 0 ? this.pages.page : 1, //页码，默认1
          size: Object.keys(this.pages).length > 0 ? this.pages.size : 25 //每页数量，默认25
        };
        // 判断如果有值为真的情况下传参,否则不传
        if (this.nickname) {
          this.obj['nickname'] = this.nickname;
        }
        if (this.buy_time.length > 0) {
          this.obj['start_time'] = this.buy_time[0]; //开始时间
          this.obj['end_time'] = this.buy_time[1]; //结束时间
        }
        promoterLogs(this.obj).then((data) => {
          this.list = data.list;
          this.pages = data.pager;

          this.$hideLoading();
        }).catch((err) => {
          this.$hideLoading();
        });
      }
    },
    created() {
      this.pullData();
    }
}
</script>
<style lang="scss" scoped>
.headimgurl {
  width: 100px;
  height: 100px;
}

.box {
  margin-bottom: 20px;
}

.content {
  padding: 20px;
}

.pages {
  text-align: right;
  margin-top: 30px;
}

.userinfo {
  display: flex;
  align-items: center;
  img {
    width: 40px;
    height: 40px;
    border-radius: 50%;
    margin-right: 15px;
  }
}

.search {
  display: flex;
  margin-bottom: 20px;
}

.search.search-btn {
  flex: 1;
}

.search-gropu {
  flex: 1;
}

.search-child {
  margin-left: 20px;
  width: 200px;
}

.buy-time {
  margin-left: 20px;
}
</style>
<style lang="scss">
.buy-time input {
  background-color: transparent !important;
  width: 60% !important;
}
</style>
